import DataConnection from "../singleton/data-connection";

export default {

    getAll: DataConnection.getAll.bind(DataConnection),

    delete: DataConnection.delete.bind(DataConnection),

    esteblish: DataConnection.esteblish.bind(DataConnection),

    syncSchema: DataConnection.syncSchema.bind(DataConnection),

    syncData: DataConnection.syncData.bind(DataConnection)

}